import nodeService from '@/services/nodejs'
import { ensureBookingCostumer } from '../bookingIdentity'

const fetchItineraries = (state, formDate) => {
  state.commit('SET_ISLOADING', true)

  nodeService
    .getOperations(formDate)
    .then((res) => {
      var response = res.data
      state.commit('SET_CALENDAR_DATA', response)
      state.commit('SET_ISLOADING', false)
    })
    .catch((error) => {})
}

const verifyBookings = async (state, date) => {
  state.commit('SET_ISLOADING', true)

  await nodeService
    .verifyBookings(date)
    .then((res) => {
      state.commit('SET_VERIFIED_BOOKINGS', true)
      state.commit('SET_ISLOADING', false)
    })
    .catch((error) => {
      state.commit('SET_VERIFIED_BOOKINGS', false)
    })
}

const blockDayProduct = (state, payload) => {
  state.commit('SET_ISLOADING', true)

  nodeService
    .postBlockDayProduct(payload)
    .then((res) => {
      state.commit('SET_ISLOADING', false)
    })
    .catch((error) => {})
}

const unblockDayProduct = (state, payload) => {
  state.commit('SET_ISLOADING', true)

  nodeService
    .postUnblockDayProduct(payload)
    .then((res) => {
      state.commit('SET_ISLOADING', false)
    })
    .catch((error) => {})
}

const fetchBookingByUUID = async (state, UUID) => {
  state.commit('SET_ISLOADING', true)
  state.commit('RESET_BILL_ITEM_DETAILS')

  await nodeService
    .getBookingByUUID(UUID)
    .then((res) => {
      var response = res.data

      response.forEach((e, index) => {
        e.payload =
          typeof e.payload == 'string' ? JSON.parse(e.payload) : e.payload

        const approvedPayments = e.payload.payments.filter(
          (payment) =>
            payment.payment_status === 'APPROVED' ||
            payment.payment_status === 'COMPLETE'
        )

        response[index].paymentMethod = approvedPayments
          .reduce((prev, curr) => {
            if (curr.payment_method) {
              prev.push(curr.payment_method)
            }
            return prev
          }, [])
          .join(', ')

        response[index].paymentDescription = response[
          index
        ].paymentDescription = approvedPayments
          .reduce((prev, curr) => {
            if (curr.payment_description) {
              prev.push(curr.payment_description)
            }
            return prev
          }, [])
          .join(', ')

        updateStatus(state, response[index], true)
      })

      state.commit('SET_BOOKING_DETAILS', response)
      state.commit('SET_ISLOADING', false)
    })
    .catch(() => {
      console.warn(`booking not found: ${UUID}`)
    })
}

function formatDaySummary(state, bookings) {
  var daySummary = {
    Online: { Crédito: 0, Débito: 0, Pix: 0, Carteira: 0, Total: 0 },
    Localmente: { Crédito: 0, Débito: 0, Pix: 0, Dinheiro: 0, Total: 0 },
    Visitantes: { Inteira: 0, 'Meia Entrada': 0, Cortesia: 0, Total: 0 },
    'Venda Remota': {
      'Venda Remota (Site)': 0,
      'Venda Remota (Totem)': 0,
      'Venda Remota (Expessa)': 0,
      Total: 0,
    },
    'Venda Local': {
      'Venda Local (Maquininha)': 0,
      'Venda Local (Expressa com auto-checkin)': 0,
      'Registro Interno': 0,
      Total: 0,
    },
    Checkin: { 'Check-in Confirmado': 0, 'Aguardando Check-in': 0, Total: 0 },
    'Não confirmadas': { 'Não pagas': 0, Canceladas: 0 },
  }
  var daySummaryTypes = {
    wallet: 'Carteira',
    credit: 'Crédito',
    debit: 'Débito',
    pix: 'Pix',
    money: 'Dinheiro',
    cod: 'Pago ao gestor',
    cod_pix: 'Pago ao gestor (Pix)',
    cod_credit: 'Pago ao gestor (Crédito)',
    cod_debit: 'Pago ao gestor (Débito)',
    cod_money: 'Pago ao gestor (Dinheiro)',
  }

  if (bookings.length > 0) {
    bookings.forEach((booking) => {
      let channel = booking['channel']
      let paymentChannel = booking['paymentDescription']
      let finalValue = booking['finalValue']
      let itemPersonType = booking['itemPersonType']

      // checkedin amount
      switch (booking['status']) {
        case 'UNPAID':
          daySummary['Não confirmadas']['Não pagas'] += 1
          break

        case 'PENDING':
          daySummary['Não confirmadas']['Não pagas'] += 1
          break

        case 'DENIED':
          daySummary['Não confirmadas']['Não pagas'] += 1
          break

        case 'UNPAID':
          daySummary['Não confirmadas']['Cotações'] += 1
          break

        case 'CANCELLED':
          daySummary['Não confirmadas']['Canceladas'] += 1
          break

        case 'APPROVED':
          //sales amount

          if (channel == 'TRANSACTION') {
            daySummary['Venda Local']['Registro Interno'] +=
              booking['people']['tableText']['count']
            daySummary['Venda Local']['Total'] +=
              booking['people']['tableText']['count']
          } else if (channel == 'POSCONTROLE') {
            daySummary['Venda Local']['Venda Local (Maquininha)'] +=
              booking['people']['tableText']['count']
            daySummary['Venda Local']['Total'] +=
              booking['people']['tableText']['count']
          } else if (channel == 'LARAVEL') {
            daySummary['Venda Remota']['Venda Remota (Site)'] +=
              booking['people']['tableText']['count']
            daySummary['Venda Remota']['Total'] +=
              booking['people']['tableText']['count']
          } else if (channel == 'RESERVAEXPRESSA') {
            if (booking['auto_checkin']) {
              daySummary['Venda Local'][
                'Venda Local (Expressa com auto-checkin)'
              ] += booking['people']['tableText']['count']
              daySummary['Venda Local']['Total'] +=
                booking['people']['tableText']['count']
            } else {
              if (booking['device'] == 'totem') {
                daySummary['Venda Remota']['Venda Remota (Totem)'] +=
                  booking['people']['tableText']['count']
                daySummary['Venda Remota']['Total'] +=
                  booking['people']['tableText']['count']
              } else {
                daySummary['Venda Remota']['Venda Remota (Expessa)'] +=
                  booking['people']['tableText']['count']
                daySummary['Venda Remota']['Total'] +=
                  booking['people']['tableText']['count']
              }
            }
          }

          //check-in amount
          daySummary['Checkin']['Total'] +=
            booking['people']['tableText']['count']
          if (booking['checkin']['hasCheckin']) {
            daySummary['Checkin']['Check-in Confirmado'] +=
              booking['people']['tableText']['count']
          } else {
            daySummary['Checkin']['Aguardando Check-in'] +=
              booking['people']['tableText']['count']
            return
          }

          // people amount
          Object.keys(itemPersonType).forEach((personType) => {
            let _lowerPersonType = personType.toLowerCase()

            //cortesia
            if (paymentChannel.indexOf('Cortesia') != -1) {
              _lowerPersonType = 'Cortesia'
            } else {
              if (
                _lowerPersonType == 'meia' ||
                _lowerPersonType == 'meia entrada'
              ) {
                _lowerPersonType = 'Meia Entrada'
              }
              if (_lowerPersonType == 'inteira') {
                _lowerPersonType = 'Inteira'
              }
              if (_lowerPersonType == 'cortesia') {
                _lowerPersonType = 'Cortesia'
              }
            }

            if (daySummary['Visitantes'][_lowerPersonType] == undefined) {
              daySummary['Visitantes'][_lowerPersonType] = 0
            }

            daySummary['Visitantes'][_lowerPersonType] +=
              itemPersonType[personType]['count']
            daySummary['Visitantes']['Total'] +=
              itemPersonType[personType]['count']
          })

          //cortesia
          if (paymentChannel.indexOf('Cortesia') != -1) {
            return
          }

          // money value
          switch (channel) {
            case 'WORDPRESS':
              channel = 'Online'
              break

            case 'POSCONTROLE':
              channel = 'Localmente'

              booking.payments.forEach((payment) => {
                let payment_pos_type =
                  payment.data_origin.TEFType || payment.data_origin.Name

                switch (payment_pos_type) {
                  case '01':
                    paymentChannel = 'Débito'
                    break
                  case '02':
                    paymentChannel = 'Crédito'
                    break
                  case '06':
                    paymentChannel = 'Pix'
                    break
                  case 'Dinheiro':
                    paymentChannel = 'Dinheiro'
                    break
                  case 'Cortesia':
                    paymentChannel = 'Cortesia'
                    break
                  default:
                    if (
                      payment.payment_description &&
                      payment.payment_description
                        .toUpperCase()
                        .indexOf('WALLET') == 0
                    ) {
                      paymentMethod = 'Carteira'
                    } else {
                      console.error('TIPO DE PAGAMENTO DESCONHECIDO!')
                      paymentChannel = 'Dinheiro'
                    }
                }

                if (daySummary[channel] == undefined) {
                  daySummary[channel] = {}
                }
                if (daySummary[channel][paymentChannel] == undefined) {
                  daySummary[channel][paymentChannel] = 0
                }

                daySummary[channel][paymentChannel] += Number(
                  payment.payment_value
                )
                daySummary[channel]['Total'] += Number(payment.payment_value)
              })
              break

            default:
              channel = 'Online'
              break
          }

          if (channel != 'Localmente' && finalValue > 0) {
            booking.payments.forEach((payment) => {
              let current_channel = channel
              paymentChannel =
                daySummaryTypes[payment.payment_method] ||
                payment.payment_description

              if (payment.payment_method.indexOf('cod') == 0) {
                current_channel = 'Localmente'
              } else if (
                payment.payment_description &&
                payment.payment_description.toUpperCase().indexOf('WALLET') == 0
              ) {
                current_channel = 'Online'
                paymentChannel = 'Carteira'
              } else {
                current_channel = 'Online'
              }
              if (daySummary[current_channel] == undefined) {
                daySummary[current_channel] = {}
              }
              if (daySummary[current_channel][paymentChannel] == undefined) {
                let paymentChannelSummary = {}
                paymentChannelSummary[paymentChannel] = 0
                daySummary[current_channel] = {
                  ...paymentChannelSummary,
                  ...daySummary[current_channel],
                }
              }
              daySummary[current_channel][paymentChannel] += Number(
                payment.payment_value
              )
              daySummary[current_channel]['Total'] += Number(
                payment.payment_value
              )
            })
          }
          break

        default:
          break
      }
    })

    Object.keys(daySummary).forEach((channel) => {
      let _sortedItems = []

      Object.keys(daySummary[channel]).forEach((method) => {
        _sortedItems.push({ title: method, value: daySummary[channel][method] })
      })

      daySummary[channel] = _sortedItems
    })
  }

  return daySummary
}

/**
 * set booking status
 * #227BA0 Azul
 * #22A06B Verde
 * #D93051 Vermelho
 * #E67E22 Amarelo
 * #5F6368 Cinza
 *  CANCELLED: #D93051
 * APPROVED: #E67E22
 * cinza: #999
 * aguardando checkin #1A6884
 *
 * 
    cardHeaderLabel() {
      const status = String(this.booking.status || '').toUpperCase()
      if (status === 'CANCELLED') return 'cancelada'
      if (status === 'APPROVED' && !this.isBookingPaid)
        return 'Pré-reserva (aguardando pagamento)'
      if (!this.isBookingPaid) return 'cotação'
      if (this.hasCheckin) return 'ingresso utilizado'
      return 'aguardando check-in'
    },

    cardHeaderColor() {
      const status = String(this.booking.status || '').toUpperCase()
      if (status === 'CANCELLED') return '#D93051'
      if (status === 'APPROVED' && !this.isBookingPaid) return '#E67E22'
      if (!this.isBookingPaid) return '#999'
      if (this.hasCheckin) return 'rgb(32, 155, 103)'
      return '#1A6884'
    },
 * @param {*} state
 * @param {*} booking booking object
 * @param {*} hasPayloadData has or dont payload
 * @returns
 */
const updateStatus = (state, booking, hasPayloadData) => {
  //Colors
  let Azul = '#227BA0'
  let Verde = '#22A06B'
  let Vermelho = '#D93051'
  let Amarelo = '#E67E22'
  let Cinza = '#5F6368'

  // Payment methods
  let bookingPaidStatusArray = JSON.parse(
    JSON.stringify(state.rootState.operacao.bookingPaidStatusArray)
  )

  let paymentMethodsAliases = JSON.parse(
    JSON.stringify(state.rootState.operacao.paymentMethodsAliases)
  )

  let paymentMethodsAlias = []

  if (hasPayloadData) {
    booking.agents = booking.payload.agents
    booking.checkins = booking.payload.checkins
    booking.channel = booking.payload.channel
    booking.payments = booking.payload.payments
  }

  ensureBookingCostumer(booking)

  const approvedPayments = booking.payments.filter(
    (payment) =>
      payment.payment_status === 'APPROVED' ||
      payment.payment_status === 'COMPLETE'
  )

  if (booking.paymentMethod == '' || booking.paymentMethod == 'free_booking') {
    booking.paymentMethod = 'cortesia'
  }

  paymentMethodsAlias =
    paymentMethodsAliases[booking.paymentMethod.toUpperCase()]
  booking['paymentMethodOrigin'] = booking.paymentMethod

  if (booking.paymentMethod == 'pos') {
    if (booking.channel == undefined) {
      booking.channel = 'POSCONTROLE' // REMOVER NO BACKEND
    }
    booking.paymentMethod = booking.paymentDescription.split(' - ')[0]
    booking.paymentMethod = booking.paymentMethod.replace('ito', 'it')
    booking.paymentMethod = `pos_${booking.paymentMethod}`
    paymentMethodsAlias =
      paymentMethodsAliases[booking.paymentMethod.toUpperCase()]
    booking.paymentDescription = `POS - ${
      paymentMethodsAlias != undefined
        ? paymentMethodsAlias.title
        : booking.paymentMethod
    }`
  }

  if (paymentMethodsAlias == undefined) {
    booking.paymentMethod = 'UNKNOWN'
    paymentMethodsAlias =
      paymentMethodsAliases[booking.paymentMethod.toUpperCase()]
  }

  if (Object.keys(approvedPayments).length > 1) {
    booking.paymentMethod = 'MULTIPLE'
    paymentMethodsAlias =
      paymentMethodsAliases[booking.paymentMethod.toUpperCase()]
    paymentMethodsAlias.title = booking.paymentDescription
  }

  if (booking.paymentDescription.indexOf('Stripe') >= 0) {
    booking.paymentMethod = 'Stripe'
    booking.channel = 'LARAVEL'
  }

  if (
    booking.channel == undefined &&
    booking.paymentMethod.toUpperCase() == 'PIX'
  ) {
    // REMOVER NO BACKEND
    booking.channel = 'RESERVAEXPRESSA' // REMOVER NO BACKEND
  }

  if (booking.channel == undefined) {
    booking.channel = 'WORDPRESS' // REMOVER NO BACKEND
  }

  booking.paymentMethod = paymentMethodsAlias.slug
  booking.paymentDescription = paymentMethodsAlias.title
  booking.finalValue = Number(booking.valor - booking.item_discount)

  // Status (Booking, Order, Payment)
  booking.statusText = 'Pendente'
  booking.paymentStatusText = 'Pendente'
  booking.orderStatusText = 'Pendente'
  booking.channelText = ''
  booking.statusColor = Vermelho

  // payment
  const isBookingApprovedAndPaid =
    bookingPaidStatusArray.indexOf(booking.status.toUpperCase()) >= 0 &&
    booking.payments.filter(
      (payment) =>
        payment.payment_status === 'APPROVED' ||
        payment.payment_status === 'COMPLETE'
    ).length > 0

  if (isBookingApprovedAndPaid) {
    booking.statusText = 'Aguardando Check-in'
    booking.paymentStatusText = 'Pago'
    booking.orderStatusText = 'Concluído'
    booking.statusColor = Azul

    // checkins
    if (
      (booking.checkin && booking.checkin.hasCheckin) ||
      (booking.checkins && booking.checkins.length > 0)
    ) {
      booking.statusText = 'Realizada'
      booking.statusColor = Verde
    }

    // agents
    if (!booking.agents || booking.agents.length == 0) {
      // booking.statusText += ' (sem condutor)'
      booking.statusColor = Azul
    }
  }
  if (booking.status.toUpperCase() == 'CANCELLED') {
    booking.statusText = 'Cancelada'
    booking.paymentStatusText = 'Cancelado'
    booking.orderStatusText = 'Cancelado'
    booking.statusColor = Vermelho
  } else if (booking.status.toUpperCase() === 'UNPAID') {
    booking.statusText = 'Cotação'
    booking.paymentStatusText = 'Pendente'
    booking.orderStatusText = 'Pendente'
    booking.statusColor = Cinza
  } else if (
    booking.status.toUpperCase() == 'APPROVED' &&
    !isBookingApprovedAndPaid
  ) {
    booking.statusText = 'Pré-reserva'
    booking.paymentStatusText = 'Pendente'
    booking.orderStatusText = 'Pendente'
    booking.statusColor = Amarelo
  }

  //channel
  switch (booking.channel) {
    case 'WORDPRESS':
      booking.channelText = 'Site Janoo'
      break
    case 'TRANSACTION':
      booking.channelText = 'Registro Interno'
      break
    case 'RESERVAEXPRESSA':
      booking.channelText = 'Reserva Expressa'
      break
    case 'LARAVEL':
      booking.channelText = 'Site'
      break
    case 'POSCONTROLE':
      booking.channelText = 'Portaria'
      break
    default:
      break
  }

  return booking
}

const fetchBillItemsByUUID = async (state, params) => {
  state.commit('SET_ISLOADING', true)
  state.commit('RESET_BILL_ITEM_DETAILS')

  await nodeService
    .getBillItems(params)
    .then((res) => {
      var response = res.data[0]
      response = updateStatus(state, response, false)
      state.commit('SET_BILL_ITEM_DETAILS', response)
      state.commit('SET_ISLOADING', false)
    })
    .catch((error) => {
      console.error('erro ao buscar reservas', error)
    })
}

const resetBillItemDetails = (state) => {
  state.commit('RESET_BILL_ITEM_DETAILS')
}

const resetBookingDetails = (state) => {
  state.commit('RESET_BOOKING_DETAILS')
}

const operationStoreCommit = (state, payload) => {
  state.commit(payload.mutation, payload.value)
}

export default {
  fetchItineraries,
  verifyBookings,
  fetchBookingByUUID,
  fetchBillItemsByUUID,
  resetBookingDetails,
  resetBillItemDetails,
  updateStatus,
  blockDayProduct,
  unblockDayProduct,
  formatDaySummary,
  operationStoreCommit,
}
